const COLOR_MAP = {
  rojo: '#ee0000',
  verde: '#32cd32',
  amarillo: '#ffa640',
  gris: '#808080',
};

export default {
  COLOR_MAP,
};
